import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";

export interface LiveblocksAuthResponse {
  token: string;
}

/** Body the Liveblocks browser SDK sends; we forward the same shape to the API. */
export interface LiveblocksAuthPayload {
  room: string;
}

const ENDPOINTS = {
  TOKEN: "/api/v2/org/:organization_id/user/:user_id/liveblocks-token",
};

export class LiveblocksAPI {
  constructor(private client: CohesiveAPIClient) {}

  async auth(
    payload: LiveblocksAuthPayload,
    config?: AxiosRequestConfig,
  ): Promise<LiveblocksAuthResponse> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.post<{
      data: LiveblocksAuthResponse;
    }>(
      route(ENDPOINTS.TOKEN, {
        organization_id: organizationId,
        user_id: userId,
      }),
      payload,
      config,
    );
    return response.data.data;
  }
}
